import type { ConfiguredFieldOptions } from '@cims-online/shared'

/** Normalizes scalar and array selections to configured option IDs. */
export function selectedOptionIds(
  field: ConfiguredFieldOptions,
  value: unknown
) {
  if (field.type === 'selected_by')
    return typeof value === 'string' ? [value] : []
  return Array.isArray(value)
    ? value.filter(
        (optionId): optionId is string => typeof optionId === 'string'
      )
    : []
}
